.container {
  all: unset;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1.6rem;
  cursor: pointer;

  &:hover {
    p {
      transition: all 0.2s ease;
      color: var(--color-grayscale-white, #fafafa);

      &:last-child {
        color: var(--color-grayscale-athens, #e4e6ea);
      }
    }
  }
}

.item {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  min-width: 0;

  & > span {
    font-size: 1.2rem;
    font-weight: 300;
    color: var(--color-grayscale-light-slate, #7a8296);
  }

  &[data-read='false'] {
    p {
      color: var(--color-grayscale-white, #fafafa);
    }
  }

  &[data-read='true'] {
    & * {
      color: var(--color-grayscale-light-slate, #7a8296);

      &:last-child {
        color: var(--color-grayscale-light-slate, #7a8296);
      }
    }
  }
}

.unread-spot {
  width: 1rem;
  min-width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: var(--color-primary-telemagenta, #d53075);
  visibility: hidden;

  &[data-visible='true'] {
    visibility: visible;
  }
}
